import { render } from "./UKTTundideAsendamiseTabel.vue?vue&type=template&id=1e7d4ec4&scoped=true&ts=true"
import script from "./UKTTundideAsendamiseTabel.vue?vue&type=script&lang=ts"
export * from "./UKTTundideAsendamiseTabel.vue?vue&type=script&lang=ts"

import "./UKTTundideAsendamiseTabel.vue?vue&type=style&index=0&id=1e7d4ec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7d4ec4"]])

export default __exports__